import Badge from '@material-ui/core/Badge';
import Button from '@material-ui/core/Button';
import CartButton from '@material-ui/icons/ShoppingCart';
import compose from 'recompose/compose';
import config from 'shared/config';
import Customer from 'models/Customer';
import Divider from '@material-ui/core/Divider';
import FunctionButton from 'shared/components/FunctionButton';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withStyles, withTheme } from '@material-ui/core/styles';
import styles from '../styles.css';

const muiStyles = theme => ({
	// Override the MUI Badge root class
	root: {
		verticalAlign: 'initial',
		top: '10px',
	},
	// Override the MUI Badge badge class
	badge: {
		top: '0px',
		right: '0px',
		color: theme.palette.getContrastText(theme.palette.secondary.main),
	},
	badgeStyle: {
		padding: '4px 2px',
	},

	buttonStyle: {
		position: 'relative',
		'&:hover': {
			backgroundColor: 'transparent',
		},
		color: 'inherit',
	},
	customerNameMenuItem: {
		padding: '12px 8px 8px 17px',
		width: '200px',
	},
	disabledMenuItem: {
		fontSize: '0.8em',
		minHeight: 0,
		lineHeight: 1,
		padding: '0px 16px 1px 16px',
	},
	signOutMenuItem: {
		marginTop: '8px',
		paddingRight: '8px',
	},
	userIcon: {
		bottom: '2px',
		backgroundColor: theme.palette.primary.main,
		color: theme.palette.getContrastText(theme.palette.primary.main),
		padding: '0px',
		borderRadius: '50%',
		width: '40px',
		minWidth: '40px',
		'&:hover': {
			backgroundColor: theme.palette.primary.light,
		},
	},
});

class NavAppBarRightIcons extends React.Component {
	constructor() {
		super();
		this.state = {
			menuOpen: false,
		};
	}

	handleClick = event => {
		/* Per MUI, the event.preventDefault() prevents an effect called ghost click
		that happens with touch-devices. It is recommended that you add that call
		whenever you handle a click event associated with closing/opening Popover. */
		event.preventDefault();
		this.setState({
			menuOpen: true,
			anchorEl: event.currentTarget,
		});
	};

	handleRequestClose = () => {
		this.setState({
			menuOpen: false,
		});
	};

	handleSignOut = () => {
		this.handleRequestClose();
		this.props.logout();
	};

	renderLoginRegistration = initials => {
		const { classes, customer, openLogin, openRegistration } = this.props;
		return customer.isGuest ? (
			<span className={styles['nav-links']} style={{ position: 'relative' }}>
				<FunctionButton label="Log In" onClickFunction={openLogin} />
				|
				<FunctionButton
					label="Register"
					onClickFunction={openRegistration}
					style={{ fontWeight: 'bold' }}
				/>
			</span>
		) : (
			<div className={styles['user-icon-menu']}>
				<Button
					variant="text"
					label={initials}
					onClick={this.handleClick}
					className={classes.userIcon}
				>
					{initials}
				</Button>
				<Menu
					open={this.state.menuOpen}
					getContentAnchorEl={null}
					anchorEl={this.state.anchorEl}
					anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
					transformOrigin={{ vertical: 'top', horizontal: 'right' }}
					onClose={this.handleRequestClose}
					elevation={1}
				>
					<MenuItem className={classes.customerNameMenuItem}>{customer.fullName}</MenuItem>
					<MenuItem disabled className={classes.disabledMenuItem}>
						{customer.emailAddress}
					</MenuItem>
					<Divider />
					<MenuItem className={classes.signOutMenuItem} onClick={this.handleSignOut}>
						Sign Out
					</MenuItem>
				</Menu>
			</div>
		);
	};

	render() {
		const { classes, customer, toggleCartDrawer, shoppingCartQuantity } = this.props;

		// To create user icon, get first and last name
		const fullName = customer.fullName.split(' ');
		const firstName = fullName[0];
		const lastName = fullName[fullName.length - 1];
		// if there is no first/last name available, just use first initial
		const initials = fullName.length > 1 ? firstName[0] + lastName[0] : firstName[0];
		const loginMargin = config.GENERAL.ShowCart ? '-5px' : '16px';

		return (
			<div className={styles['right-display']} style={{ marginTop: loginMargin }}>
				{config.GENERAL.ShowCart ? (
					<Badge
						badgeContent={shoppingCartQuantity}
						classes={{ badge: classes.badge, root: classes.root }}
						className={classes.badgeStyle}
						color="secondary"
					>
						<IconButton onClick={toggleCartDrawer} className={classes.buttonStyle}>
							<CartButton />
						</IconButton>
					</Badge>
				) : null}
				{config.GENERAL.ShowLoginRegistration ? this.renderLoginRegistration(initials) : null}
			</div>
		);
	}
}

NavAppBarRightIcons.propTypes = {
	classes: PropTypes.shape({
		root: PropTypes.string,
		badge: PropTypes.string,
		badgeStyle: PropTypes.string,
		buttonStyle: PropTypes.string,
		customerNameMenuItem: PropTypes.string,
		disabledMenuItem: PropTypes.string,
		signOutMenuItem: PropTypes.string,
		userIcon: PropTypes.string,
	}).isRequired,
	customer: PropTypes.instanceOf(Customer).isRequired,
	logout: PropTypes.func.isRequired,
	openLogin: PropTypes.func.isRequired,
	openRegistration: PropTypes.func.isRequired,
	shoppingCartQuantity: PropTypes.number.isRequired,
	toggleCartDrawer: PropTypes.func.isRequired,
};

const mapStateToProps = state => {
	const shoppingCartQuantity = state.cart.get('shoppingCartQuantity');
	return {
		shoppingCartQuantity,
	};
};

export default compose(
	connect(mapStateToProps),
	withStyles(muiStyles, { name: 'NavAppBarRightIcons' }),
	withTheme
)(NavAppBarRightIcons);
